import React from 'react';
import { Button, ListItemIcon, Menu, MenuItem } from '@mui/material';
import { Add, ArrowDropDown } from '@mui/icons-material';
import { google, outlook, ics } from 'calendar-link';
import { FormattedMessage, useIntl } from 'react-intl';
import { stripHtml } from '../../../../../Utils';
import { Icons } from '../../../../../Themes';
import CustomIcon from '../../../../DesignSystem/CustomIcon';

function DownloadICSButton({ post }: any) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const intl = useIntl();
  const strippedDescription = stripHtml(post.description).slice(0, 170);
  const description = !post.event_url
    ? strippedDescription
    : intl.formatMessage(
        { id: 'ADD_TO_CALENDAR.URL_WITH_EVENT' },
        { description: strippedDescription, url: post.event_url },
      );
  const event = {
    title: post.title,
    description,
    start: post.start_at,
    end: post.end_at,
    location: post.location || '',
  };
  const handleClick = (e: any) => {
    setAnchorEl(e.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        color="primary"
        variant="outlined"
        aria-controls="add_to_calendar"
        aria-haspopup="true"
        startIcon={<Add />}
        size="large"
        onClick={handleClick}
        endIcon={<ArrowDropDown />}
        fullWidth
      >
        <FormattedMessage id="ADD_TO_CALENDAR.TITLE" />
      </Button>
      <Menu
        id="add_to_calendar"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        onClose={handleClose}
      >
        <MenuItem
          target="_blank"
          key="google"
          component="a"
          href={google(event)}
          title={intl.formatMessage({ id: 'BUTTONS.OPEN_IN_NEW_TAB' })}
        >
          <ListItemIcon>
            <CustomIcon src={Icons.calendar.google_cal} />
          </ListItemIcon>
          Google
        </MenuItem>
        <MenuItem
          target="_blank"
          key="outlook"
          component="a"
          href={outlook(event)}
          title={intl.formatMessage({ id: 'BUTTONS.OPEN_IN_NEW_TAB' })}
        >
          <ListItemIcon>
            <CustomIcon src={Icons.calendar.outlook_cal} />
          </ListItemIcon>
          Outlook
        </MenuItem>
        <MenuItem
          target="_blank"
          key="ics"
          component="a"
          href={ics(event)}
          title={intl.formatMessage({ id: 'BUTTONS.OPEN_IN_NEW_TAB' })}
        >
          <ListItemIcon>
            <CustomIcon src={Icons.calendar.ics_cal} />
          </ListItemIcon>
          Apple
        </MenuItem>
      </Menu>
    </>
  );
}

export default DownloadICSButton;
